module.exports = __webpack_public_path__ + "static/media/petro.b4de13ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/cat/petro.png
// module id = 112
// module chunks = 0